'use strict';

function CompanyCtrl (companyFactory, recipientsFactory, $timeout, $scope, Common, addressCalculationFactory, $q,
  postalCodesFactory) {
  const vm = this;

  const checkbox = companyFactory.checkbox;
  const slider = companyFactory.slider;

  // events
  pnTopbar.onChangeLanguage = function (language) {
    vm.language = language; // dynamically update language
  };

  pnTopbar.onChangeMarket = function (market) {
    vm.market = market; // dynamically update market
  };

  function sliderUpdated () {
    companyFactory.save();
    addressCalculationFactory.computeRefinedCount(vm.constructRequest(), true);
  }

  function isDoneFetching () {
    return vm.doneFetching;
  }

  function isFetchingGrossCount () {
    return addressCalculationFactory.getUpdateSyncParams().isFetchingGrossCount;
  }

  function isFetchingRefinedCount () {
    return addressCalculationFactory.getUpdateSyncParams().isFetchingRefinedCount;
  }

  // init
  vm.formatNumberForSummary = addressCalculationFactory.formatNumberForSummary;
  vm.showError = addressCalculationFactory.showError;
  vm.language = pnTopbar.language;
  vm.market = pnTopbar.market;
  vm.addressLimit = recipientsFactory.addressLimit; // min/max values for amount of recipients
  vm.form = {};

  // methods
  vm.constructRequest = companyFactory.constructRequest;
  vm.isDoneFetching = isDoneFetching;
  vm.isFetchingGrossCount = isFetchingGrossCount;
  vm.isFetchingRefinedCount = isFetchingRefinedCount;
  vm.formatNumber = Common.formatNumber;

  // set postal codes in addressCalculationFactory
  postalCodesFactory.setPostalCodesSelectedAreas();
  addressCalculationFactory.setRefinedGross();

  $q.all([
    checkbox.construct('employments'),
    checkbox.construct('activity'),
    slider.construct('turnover', _.debounce(sliderUpdated, 400)),
    slider.construct('numberOfEmployees', _.debounce(sliderUpdated, 400))
  ]).then(function () {
    vm.form = companyFactory.form;

    $timeout(function () {
      $scope.$broadcast('rzSliderForceRender');
    });

    vm.doneFetching = true;
    if (postalCodesFactory.zipcodes && postalCodesFactory.zipcodes.length) {
      // setting second parameter to true since there is no input validation in place for company filters
      addressCalculationFactory.computeAddressCount(vm.constructRequest());
    }
  }).catch((err) => {
    // TODO: should do something here that will display an error message on the f/e
    console.log(err);
  });
}

angular.module('web2print.recipients')
  .controller('CompanyCtrl', CompanyCtrl);

CompanyCtrl.$inject = ['companyFactory', 'recipientsFactory', '$timeout', '$scope', 'Common', 'addressCalculationFactory', '$q', 'postalCodesFactory'];
